<template>
	<b-row>
		<b-overlay :show="loading" no-wrap rounded></b-overlay>


		<div v-if="_getSuppliersWithService==null" class="w-100 text-center">
			<label class="text-danger ">No existen proveedores para el servicio o para las zonas</label>
		</div>
		<div class="w-100" v-else>
			<div class="container">
				<div class="row no-gutters">
					<div class="col-6 pr-md-5 pl-2" v-if="_getSuppliersWithService !== null">
						<div class="h-100 u:text-size-3 rounded text-white bg-primary p-1 text-center"> {{serviceType.name}} <br> <strong class="u:text-size-2">Servicio de la reserva</strong></div>
					</div>
					<div class="col-6 pl-md-5 pl-2" v-if="_getSuppliersWithService !== null">
						<div class="h-100 u:text-size-3 rounded text-white bg-success p-1 text-center">{{salesChannel}}: ${{bookingInfo.bookingTotal}} <span class="uppercase">{{bookingInfo.bookingCurrency}}</span> <br> <strong class="u:text-size-2">Costo Canal de Venta </strong></div>
					</div>
				</div>
			</div>
			<!-- <b-col md="4" v-if="_getSuppliersWithService !== null">
				<div class="u:text-size-4"><b-badge variant="info"><strong>Servicio de la reserva:</strong> {{serviceType}}</b-badge></div>
			</b-col>
			<b-col v-if="_getSuppliersWithService !== null">
				<div class="text-md-right u:text-size-4"><b-badge variant="primary">Costo Canal de Venta {{salesChannel}}: ${{bookingInfo.bookingTotal}} <span class="uppercase">{{bookingInfo.bookingCurrency}}</span></b-badge></div>
			</b-col> -->

			<b-col cols="12" class="mt-2" v-if="_getSuppliersWithService !== null">
				<b-alert variant="secondary" show>
					<p class="mb-1">Zona Origen: <strong>{{bookingInfo.pickup}}</strong></p>
					<p class="mb-1">Zona Destino: <strong>{{bookingInfo.dropoff}}</strong></p>
				</b-alert>
			</b-col>
			<b-col cols="12" class="mt-2">
				<h4 v-if="_getSuppliersWithService === null" class="text-center">No se encuentran tarifas disponibles</h4>
				<b-tabs content-class="mt-3" fill v-else>
					<b-tab :title="'Proveedores con el servicio: '+serviceType.name" active>
						<b-table
							striped
							hover
							bordered
							stacked="sm"
							responsive="md"
							:items="_getSuppliersWithService"
							:fields="fields"
							sort-by="revenue"
							:sort-desc="true"
							:key="tableWithServiceKey"
							ref="tableWithService">
							<template #cell(supplierName)="data">
								<md-icon v-b-tooltip.hover title="Proveedor actual" class="text-success" v-if="data.item.supplierId === supplierId" icon="verified" /> {{data.item.supplierName}}
							</template>
							<template #cell(serviceType)="data">
								<b-form-select
									size="sm"
									@change="onChangeServiceType($event, data.item, 'withTheService')"
									v-model="data.item.serviceTypeId"
									:options="data.item.serviceTypes"
									value-field="id"
									text-field="name"
									required
								/>
								<label v-if="serviceTypeCategory.id != data.item.categoryId" class="text-danger mb-0" style="font-size:10px">La seleccion es distinto al servicio de la reserva</label>
							</template>
							<template #cell(price)="data">
								<p class="mb-0 uppercase text-right w-100" :class="(data.item.supplierDiscount > 0? 'active-discount':'')">${{data.item.price}} {{data.item.priceCurrency}} </p>
								<p class="mb-0 uppercase text-right w-100" v-if="data.item.supplierDiscount > 0">${{data.item.supplierDiscount}} {{data.item.priceCurrency}}</p>
								<p class="mb-0 uppercase text-right w-100" v-if="data.item.priceConverted != null"><small>(${{data.item.priceConverted}} {{bookingInfo.bookingCurrency}})</small></p>
							</template>
							<template #cell(revenue)="data">
								<p class="text-danger uppercase text-right w-100" v-if="data.item.revenue < 0">${{data.item.revenue}} {{bookingInfo.bookingCurrency}} </p>
								<p class="text-success uppercase text-right w-100" v-else>${{data.item.revenue}} {{bookingInfo.bookingCurrency}} </p>
							</template>
							<template #cell(action)="data">
								<b-button :disabled="unableEdit" variant="outline-primary"  @click="eventGetDataItem(data)" size="sm">Seleccionar</b-button>
							</template>
						</b-table>
					</b-tab>
					<b-tab title="Proveedores para las zonas">
						<b-table
							striped
							hover
							bordered
							stacked="sm"
							responsive="md"
							:items="_getSuppliersForArea"
							:fields="fields"
							sort-by="revenue"
							:sort-desc="true"
							:key="tableSuppliersForArea"
							ref="tableSuppliersForArea">
							<template #cell(supplierName)="data">
								<md-icon v-b-tooltip.hover title="Proveedor actual" class="text-success" v-if="data.item.supplierId === supplierId" icon="verified" /> {{data.item.supplierName}}
							</template>
							<template #cell(serviceType)="data">
								<b-form-select
									size="sm"
									@change="onChangeServiceType($event, data.item, 'Other')"
									v-model="data.item.serviceTypeId"
									:options="data.item.serviceTypes"
									value-field="id"
									text-field="name"
									required
								/>
							</template>
							<template #cell(price)="data">
								<p class="mb-0 uppercase text-right w-100" :class="(data.item.supplierDiscount > 0? 'active-discount':'')">${{data.item.price}} {{data.item.priceCurrency}} </p>
								<p class="mb-0 uppercase text-right w-100" v-if="data.item.supplierDiscount > 0">${{data.item.supplierDiscount}} {{data.item.priceCurrency}}</p>
								<p class="mb-0 uppercase text-right w-100" v-if="data.item.priceConverted != null"><small>(${{data.item.priceConverted}} {{bookingInfo.bookingCurrency}})</small></p>
							</template>
							<template #cell(revenue)="data">
								<p class="text-danger uppercase" v-if="data.item.revenue < 0">${{data.item.revenue}} {{bookingInfo.bookingCurrency}} </p>
								<p class="text-success uppercase" v-else>${{data.item.revenue}} {{bookingInfo.bookingCurrency}} </p>
							</template>
							<template #cell(action)="data">
								<b-button :disabled="unableEdit" variant="outline-primary" @click="eventGetDataItem(data)" size="sm">Seleccionar</b-button>
							</template>
						</b-table>
					</b-tab>
				</b-tabs>
			</b-col>
		</div>
	</b-row>
</template>

<script>
import { mapFields } from "../helpers/helpers";

export default {
	props: {
		index: Number,
        transportServiceId: {
            required: true,
            type: Number,
            default: -1,
        },
		unableEdit:Boolean
    },
	data() {
      return {
		tableWithServiceKey: 0,
		tableSuppliersForArea: 0,
		loading: true,
		costs: [],
		bookingInfo: [],
		fields: [
			{ key: 'supplierName', label: 'Proveedor', sortable: true, },
			{ key: 'serviceType', label: 'Tipo de servicio', sortable: false, },
			{ key: 'price', label: 'Costo', sortable: true,},
			{ key: 'revenue', label: 'Ganancia', sortable: true, },
			{ key: 'action', label: 'Acción', thClass: 'text-center', tdClass: 'text-center', sortable: false,},
		]
      }
    },
	beforeCreate() {
		this.$options.computed = {
			...mapFields({
				fields: [
					"id",
					"pickup",
					"dropoff",
					"serviceTypeId",
					"serviceType",
					"serviceTypeCategory",
					'supplierServiceTypeId',
					"supplierId",
					"salesChannelId",
				],
				fieldArray: "transportServices",
				index: this.$options.propsData.index,
				base: "viewModel",
				mutation: "SET_UPDATE_MODEL_ARRAY",
				module: "reservation"
			}),

			salesChannel() {
				if(this.costs==null){
					return "";
				}
				return this.$root.auxVars.salesChannelsOpts.find(
					st => st.value === this.salesChannelId
				).text
			},
			_getSuppliersWithService(){
				if(this.costs==null){
					return null;
				}
				//filtramos todos los proveedores
				return this.costs.filter((supplier) => {
					//buscamos si tienen servicios igual al servicio requerido
					let services =supplier.serviceTypes.filter((serviceType)=>{
						return serviceType.categoryId==this.serviceTypeCategory.id;
					});

					//actualizamos las propiedades auxiliares que sirven como indice(v-model)
					if(services.length){
						const service = this.getBestServiceType(services)
						supplier.categoryId = service.categoryId
						supplier.serviceTypeId = service.id;
						supplier.price=service.quote.price;
						supplier.priceCurrency=service.quote.priceCurrency;
						supplier.priceConverted = service.quote.priceConverted
						supplier.revenue=service.quote.revenue;
						supplier.supplierDiscount=service.quote.supplierDiscount;

					}
					if(supplier.supplierId === this.supplierId){
						supplier.serviceTypeId = this.supplierServiceTypeId
					}
					//retornamos el item encontrado si es diferente de undefined
					return services.length;
				});
			},
			_getSuppliersForArea(){
				if(this.costs==null){
					return null;
				}
				//filtramos todos los proveedores
				return this.costs.filter((supplier) => {
					//buscamos si tienen servicios igual al servicio requerido
					let service=supplier.serviceTypes.find((serviceType)=>{
						return serviceType.categoryId==this.serviceTypeCategory.id;
					});
					//no existe un servicio igual al requerido?
					if(service == undefined){
						//actualizamos las propiedades auxiliares con el valor del primer servicio del proveedor
						supplier.serviceTypeId = supplier.serviceTypes[0].id;
						supplier.price=supplier.serviceTypes[0].quote.price;
						supplier.priceCurrency=supplier.serviceTypes[0].quote.priceCurrency;
						supplier.priceConverted = supplier.serviceTypes[0].quote.priceConverted
						supplier.revenue=supplier.serviceTypes[0].quote.revenue;
						supplier.supplierDiscount=supplier.serviceTypes[0].quote.supplierDiscount;
					}
					if(supplier.supplierId === this.supplierId){
						supplier.serviceTypeId = this.supplierServiceTypeId
					}
					//retornamos el item no encontrado, si es igual de undefined
					return service == undefined;
				});
			}
		}
	},
	methods: {
		getBestServiceType(serviceTypes){
			let oldDiff = Infinity
			let currentDiff = 0
			let serviceType = null
			serviceTypes.forEach((sv) => {
				currentDiff = Math.abs(sv.maxPax - this.serviceType.maxPax)
				if(currentDiff < oldDiff) {
					oldDiff = currentDiff
					serviceType = JSON.parse(JSON.stringify(sv))
				}
			})
			return serviceType
		},
		eventGetDataItem({item}) {
			const serviceName = item.serviceTypes.find(({id}) => id === item.serviceTypeId)?.name
			this.$emit('getDataSupplier', item.supplierId, item.serviceTypeId, serviceName)
		},
		onChangeServiceType(event, item, sectionTab){
			//recuperamos el id del tipo de servicio seleccionado
			let serviceTypeIdSelected=event;
			//recuperamos los detalles del tipo de servicio con el id
			let serviceTypeDataResult = item.serviceTypes.find(element=>{
				return element.id == serviceTypeIdSelected;
			})
			//existe algun tipo de servicio con el mismo id?
			if(serviceTypeDataResult){
				//el registro pertenece al 1er tab?
				if(sectionTab=="withTheService"){
					//iteramos en la lista se los proveedores con servicios iguales
					this._getSuppliersWithService.forEach(element=>{
						//recuperamos el proveedor por el id
						//el id del item seleccionado es igual que algun id del registro?
						if(element.supplierId==item.supplierId){
							// modificamos las variables auxiliares dentro de proveedores
							element.serviceTypeId = serviceTypeDataResult.id;
							element.categoryId = serviceTypeDataResult.categoryId
							element.price= serviceTypeDataResult.quote.price;
							element.priceCurrency=serviceTypeDataResult.quote.priceCurrency;
							element.priceConverted = serviceTypeDataResult.quote.priceConverted
							element.revenue=serviceTypeDataResult.quote.revenue;
							element.supplierDiscount=serviceTypeDataResult.quote.supplierDiscount;
							//refrescamos la tabla
							this.$refs.tableWithService.refresh();
							this.tableWithServiceKey ++
						}
					});
				//consuta al contenido del 2do tab
				}else{
					//iteramos en la lista se los proveedores con servicios iguales
					this._getSuppliersForArea.forEach(element=>{
						//recuperamos el proveedor por el id
						//el id del item seleccionado es igual que algun id del registro?
						if(element.supplierId==item.supplierId){
							// modificamos las variables auxiliares dentro de proveedores
							element.serviceTypeId = serviceTypeDataResult.id;
							element.price=serviceTypeDataResult.quote.price;
							element.priceCurrency=serviceTypeDataResult.quote.priceCurrency;
							element.priceConverted = serviceTypeDataResult.quote.priceConverted
							element.revenue=serviceTypeDataResult.quote.revenue;
							element.supplierDiscount=serviceTypeDataResult.quote.supplierDiscount;
							//refrescamos la tabla
							this.$refs.tableSuppliersForArea.refresh();
							this.tableSuppliersForArea ++
						}
					});
				}
			}
		},
		getCosts() {
			this.loading = true

			const data = {
				transportServiceId: this.transportServiceId
			}

			this.$root.api.post('transport-services/search-supplier-prices', data).then(res => {
				this.bookingInfo = res.data.bookingInfo
				this.costs = res.data.suppliers
				//a cada registro devuelto agregamos 4 variables auxiliares,
				//donde se guardaran gosto, ganancia, serviceTypeId y tipo de moneda
				//es disntinto de null?
				if(this.costs!=null){
					this.costs.forEach((item=>{
						// llaves con valores por defecto
						let keysToBeAdded={
							//ingresamos el valor del id del servicio actual para que en el input select se seleccione automaticamente
							serviceTypeId:this.serviceTypeId,
							price:0,
							priceCurrency:'mxn',
							auxRevenue:0
						};
						// inyectamos las nuevas llaves a cada item de los registros
						Object.assign(item, keysToBeAdded);
					}))
				}else{
					this.loading = false;
				}
			}).catch(this.$root.handleRequestError).then(()=>{
				this.loading = false
			});
		}
	},
	mounted() {
		this.getCosts();
	},
};
</script>

<style scoped>
.badge {
	font-weight: normal;
}
.uppercase {
	text-transform: uppercase !important;
}
.active-discount{
	text-decoration:line-through;
    color: rgb(132, 132, 132);
	font-size: 0.7rem;
	width: 100%;
	text-align: end;
}
</style>
